import { createReducer, on } from "@ngrx/store";
import { sportCountriesDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";

export const initialState: sportCountriesDataModel = {
  parentId: "",
  highlights: [],
  countries: [],
};

export const SportsbookSportCountriesReducer = createReducer(
  initialState,
  on(SportsbookActions.setSportCountries, (state, sportCountriesData) => ({
    ...state,
    ...sportCountriesData,
  })),
  on(SportsbookActions.clearSportCountries, (state) => ({
    ...state,
    ...initialState,
  })),
);
